module.exports = __webpack_public_path__ + "static/media/glacier.e4fc3f04.jpg";